const headers = {
  name: "Balance Logs",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search by reference number or description",
      value: "",
    },
    {
      type: "filter",
      name: "type",
      placeholder: "Transaction Type",
      value: null,
      allowClear: true,
      showSearch: false,
      filterOption: true,
      options: [
        {
          value: "deposit",
          label: "Deposit",
        },
        {
          value: "payment",
          label: "Payment",
        },
      ],
    },
    {
      type: "filter",
      name: "payment_method",
      placeholder: "Payment Method",
      value: null,
      allowClear: true,
      showSearch: false,
      filterOption: true,
      options: [
        {
          value: "Cash",
          label: "Cash",
        },
        {
          value: "Debit card",
          label: "Debit card",
        },
        {
          value: "Bank transfer",
          label: "Bank transfer",
        },
        {
          value: "Credit card",
          label: "Credit card",
        },
        {
          value: "Cheque",
          label: "Cheque",
        },
        {
          value: "Online payment",
          label: "Online payment",
        },
      ],
    },
    {
      type: "range",
      name: "date",
      placeholder: ["Start Date", "End Date"],
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Customers",
        path: "/app/customers",
      },
       {
        name: "Clearing Balances",
        path: "/app/customers/clearing-balance",
      },
      {
        name: "Balance Logs",
        path: "",
      },
    ],
  },
};

export default headers;